// ============================================================
// src/components/LoginPage.jsx
// Pantalla de acceso al sistema — autenticación con JWT
// ============================================================
import React, { useState } from 'react';
import {
  Box, Paper, TextField, Button, Typography,
  InputAdornment, IconButton, Alert, CircularProgress
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import api from '../services/api';

const LOGO_URL = 'https://www.inflablesdasilva.com/wp-content/uploads/2026/02/WhatsApp-Image-2026-02-16-at-6.45.52-AM-1.jpeg';

export default function LoginPage({ onLogin }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPwd,  setShowPwd]  = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    try {
      setLoading(true);
      setError('');
      const res = await api.post('/auth/login', { email: email.trim(), password });
      const { token, user } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      onLogin(token, user);
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Error al iniciar sesión';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: '#f0f4ff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage: 'radial-gradient(ellipse at 60% 40%, #dbeafe 0%, #f0f4ff 70%)',
    }}>
      <Paper elevation={4} sx={{ p: 4, width: '100%', maxWidth: 400, borderRadius: 3 }}>
        {/* Logo */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <img src={LOGO_URL} alt="Inflables Da Silva" style={{ height: 64, objectFit: 'contain' }} />
        </Box>

        {/* Título */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
          <LockOutlinedIcon color="primary" />
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Acceso al Sistema
          </Typography>
        </Box>

        {/* Formulario */}
        <Box component="form" onSubmit={handleSubmit}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
          )}

          <TextField
            fullWidth label="Correo electrónico o usuario"
            type="text" autoComplete="username" autoFocus
            value={email} onChange={e => setEmail(e.target.value)}
            sx={{ mb: 2 }}
            disabled={loading}
            helperText="Ej: admin@empresa.com  o  EMP-0001"
          />

          <TextField
            fullWidth label="Contraseña"
            type={showPwd ? 'text' : 'password'}
            autoComplete="current-password"
            value={password} onChange={e => setPassword(e.target.value)}
            sx={{ mb: 3 }}
            disabled={loading}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPwd(v => !v)} edge="end">
                    {showPwd ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Button
            type="submit" variant="contained" fullWidth size="large"
            disabled={loading || !email || !password}
            sx={{ py: 1.5, fontWeight: 700 }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Ingresar'}
          </Button>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', mt: 2 }}>
          Inflables Da Silva & FunPark © {new Date().getFullYear()}
        </Typography>
      </Paper>
    </Box>
  );
}
